import { JwtHelperService } from '@auth0/angular-jwt'
import moment from 'moment'

export function isAccessTokenExpired(accessToken: string): boolean {
  const helper = new JwtHelperService()
  const expirationDate = helper.getTokenExpirationDate(accessToken)
  const expirationMoment = moment(expirationDate)
  const currentMoment = moment(new Date())
  const differenceInMinutes = expirationMoment.diff(
    currentMoment,
    'minutes',
    true
  )
  return differenceInMinutes <= 0
}
